/* istanbul ignore file */

export const RELATED_CATEGORIES_TITLE = 'You might also like';
